import { render, staticRenderFns } from "./printDocumentFull.vue?vue&type=template&id=45ae1b24&"
import script from "./printDocumentFull.vue?vue&type=script&lang=js&"
export * from "./printDocumentFull.vue?vue&type=script&lang=js&"
import style0 from "./printDocumentFull.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../Users/Mac/Desktop/Code/permtang/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports